import { render } from "./NameAge.vue?vue&type=template&id=7708f0d6"
import script from "./NameAge.vue?vue&type=script&lang=js"
export * from "./NameAge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__